import projection from '../generated/pwp501f1.json';
import { AcceptanceManifest } from '../types';

export const pwp501f1AcceptanceManifest = projection as AcceptanceManifest;
